/**
 * @fileoverview gRPC-Web generated client stub for social.ai
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.21.12
// source: services/ai/ai.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var services_common_common_pb = require('../../services/common/common_pb.js')
const proto = {};
proto.social = {};
proto.social.ai = require('./ai_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.social.ai.AiServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.social.ai.AiServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.common.Pong>}
 */
const methodDescriptor_AiService_Ping = new grpc.web.MethodDescriptor(
  '/social.ai.AiService/Ping',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Empty,
  services_common_common_pb.Pong,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Pong.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Pong)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Pong>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.ai.AiServiceClient.prototype.ping =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.ai.AiService/Ping',
      request,
      metadata || {},
      methodDescriptor_AiService_Ping,
      callback);
};


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Pong>}
 *     Promise that resolves to the response
 */
proto.social.ai.AiServicePromiseClient.prototype.ping =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.ai.AiService/Ping',
      request,
      metadata || {},
      methodDescriptor_AiService_Ping);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.ai.Chat,
 *   !proto.social.ai.Chat>}
 */
const methodDescriptor_AiService_CreateChat = new grpc.web.MethodDescriptor(
  '/social.ai.AiService/CreateChat',
  grpc.web.MethodType.UNARY,
  proto.social.ai.Chat,
  proto.social.ai.Chat,
  /**
   * @param {!proto.social.ai.Chat} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.ai.Chat.deserializeBinary
);


/**
 * @param {!proto.social.ai.Chat} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.ai.Chat)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.ai.Chat>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.ai.AiServiceClient.prototype.createChat =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.ai.AiService/CreateChat',
      request,
      metadata || {},
      methodDescriptor_AiService_CreateChat,
      callback);
};


/**
 * @param {!proto.social.ai.Chat} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.ai.Chat>}
 *     Promise that resolves to the response
 */
proto.social.ai.AiServicePromiseClient.prototype.createChat =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.ai.AiService/CreateChat',
      request,
      metadata || {},
      methodDescriptor_AiService_CreateChat);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.ai.Chat,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AiService_DeleteChat = new grpc.web.MethodDescriptor(
  '/social.ai.AiService/DeleteChat',
  grpc.web.MethodType.UNARY,
  proto.social.ai.Chat,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.ai.Chat} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.ai.Chat} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.ai.AiServiceClient.prototype.deleteChat =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.ai.AiService/DeleteChat',
      request,
      metadata || {},
      methodDescriptor_AiService_DeleteChat,
      callback);
};


/**
 * @param {!proto.social.ai.Chat} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.ai.AiServicePromiseClient.prototype.deleteChat =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.ai.AiService/DeleteChat',
      request,
      metadata || {},
      methodDescriptor_AiService_DeleteChat);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.ai.ListChatRequest,
 *   !proto.social.ai.ChatsListResponse>}
 */
const methodDescriptor_AiService_ListChat = new grpc.web.MethodDescriptor(
  '/social.ai.AiService/ListChat',
  grpc.web.MethodType.UNARY,
  proto.social.ai.ListChatRequest,
  proto.social.ai.ChatsListResponse,
  /**
   * @param {!proto.social.ai.ListChatRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.ai.ChatsListResponse.deserializeBinary
);


/**
 * @param {!proto.social.ai.ListChatRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.ai.ChatsListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.ai.ChatsListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.ai.AiServiceClient.prototype.listChat =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.ai.AiService/ListChat',
      request,
      metadata || {},
      methodDescriptor_AiService_ListChat,
      callback);
};


/**
 * @param {!proto.social.ai.ListChatRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.ai.ChatsListResponse>}
 *     Promise that resolves to the response
 */
proto.social.ai.AiServicePromiseClient.prototype.listChat =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.ai.AiService/ListChat',
      request,
      metadata || {},
      methodDescriptor_AiService_ListChat);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.ai.Chat,
 *   !proto.social.ai.Chat>}
 */
const methodDescriptor_AiService_UpdateChat = new grpc.web.MethodDescriptor(
  '/social.ai.AiService/UpdateChat',
  grpc.web.MethodType.UNARY,
  proto.social.ai.Chat,
  proto.social.ai.Chat,
  /**
   * @param {!proto.social.ai.Chat} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.ai.Chat.deserializeBinary
);


/**
 * @param {!proto.social.ai.Chat} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.ai.Chat)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.ai.Chat>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.ai.AiServiceClient.prototype.updateChat =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.ai.AiService/UpdateChat',
      request,
      metadata || {},
      methodDescriptor_AiService_UpdateChat,
      callback);
};


/**
 * @param {!proto.social.ai.Chat} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.ai.Chat>}
 *     Promise that resolves to the response
 */
proto.social.ai.AiServicePromiseClient.prototype.updateChat =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.ai.AiService/UpdateChat',
      request,
      metadata || {},
      methodDescriptor_AiService_UpdateChat);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.ai.GetMessagesRequest,
 *   !proto.social.ai.GetMessagesListResponse>}
 */
const methodDescriptor_AiService_ListChatMessages = new grpc.web.MethodDescriptor(
  '/social.ai.AiService/ListChatMessages',
  grpc.web.MethodType.UNARY,
  proto.social.ai.GetMessagesRequest,
  proto.social.ai.GetMessagesListResponse,
  /**
   * @param {!proto.social.ai.GetMessagesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.ai.GetMessagesListResponse.deserializeBinary
);


/**
 * @param {!proto.social.ai.GetMessagesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.ai.GetMessagesListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.ai.GetMessagesListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.ai.AiServiceClient.prototype.listChatMessages =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.ai.AiService/ListChatMessages',
      request,
      metadata || {},
      methodDescriptor_AiService_ListChatMessages,
      callback);
};


/**
 * @param {!proto.social.ai.GetMessagesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.ai.GetMessagesListResponse>}
 *     Promise that resolves to the response
 */
proto.social.ai.AiServicePromiseClient.prototype.listChatMessages =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.ai.AiService/ListChatMessages',
      request,
      metadata || {},
      methodDescriptor_AiService_ListChatMessages);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.ai.Message,
 *   !proto.social.ai.SendMessageResponse>}
 */
const methodDescriptor_AiService_SendMessage = new grpc.web.MethodDescriptor(
  '/social.ai.AiService/SendMessage',
  grpc.web.MethodType.UNARY,
  proto.social.ai.Message,
  proto.social.ai.SendMessageResponse,
  /**
   * @param {!proto.social.ai.Message} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.ai.SendMessageResponse.deserializeBinary
);


/**
 * @param {!proto.social.ai.Message} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.ai.SendMessageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.ai.SendMessageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.ai.AiServiceClient.prototype.sendMessage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.ai.AiService/SendMessage',
      request,
      metadata || {},
      methodDescriptor_AiService_SendMessage,
      callback);
};


/**
 * @param {!proto.social.ai.Message} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.ai.SendMessageResponse>}
 *     Promise that resolves to the response
 */
proto.social.ai.AiServicePromiseClient.prototype.sendMessage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.ai.AiService/SendMessage',
      request,
      metadata || {},
      methodDescriptor_AiService_SendMessage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.FindRequest,
 *   !proto.social.ai.VectorStoreListResponse>}
 */
const methodDescriptor_AiService_GetVectorStores = new grpc.web.MethodDescriptor(
  '/social.ai.AiService/GetVectorStores',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.FindRequest,
  proto.social.ai.VectorStoreListResponse,
  /**
   * @param {!proto.social.common.FindRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.ai.VectorStoreListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.FindRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.ai.VectorStoreListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.ai.VectorStoreListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.ai.AiServiceClient.prototype.getVectorStores =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.ai.AiService/GetVectorStores',
      request,
      metadata || {},
      methodDescriptor_AiService_GetVectorStores,
      callback);
};


/**
 * @param {!proto.social.common.FindRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.ai.VectorStoreListResponse>}
 *     Promise that resolves to the response
 */
proto.social.ai.AiServicePromiseClient.prototype.getVectorStores =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.ai.AiService/GetVectorStores',
      request,
      metadata || {},
      methodDescriptor_AiService_GetVectorStores);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.ai.KnowledgeRecommendation,
 *   !proto.social.ai.KnowledgeRecommendation>}
 */
const methodDescriptor_AiService_GetKnowledgeRecommendation = new grpc.web.MethodDescriptor(
  '/social.ai.AiService/GetKnowledgeRecommendation',
  grpc.web.MethodType.UNARY,
  proto.social.ai.KnowledgeRecommendation,
  proto.social.ai.KnowledgeRecommendation,
  /**
   * @param {!proto.social.ai.KnowledgeRecommendation} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.ai.KnowledgeRecommendation.deserializeBinary
);


/**
 * @param {!proto.social.ai.KnowledgeRecommendation} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.ai.KnowledgeRecommendation)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.ai.KnowledgeRecommendation>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.ai.AiServiceClient.prototype.getKnowledgeRecommendation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.ai.AiService/GetKnowledgeRecommendation',
      request,
      metadata || {},
      methodDescriptor_AiService_GetKnowledgeRecommendation,
      callback);
};


/**
 * @param {!proto.social.ai.KnowledgeRecommendation} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.ai.KnowledgeRecommendation>}
 *     Promise that resolves to the response
 */
proto.social.ai.AiServicePromiseClient.prototype.getKnowledgeRecommendation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.ai.AiService/GetKnowledgeRecommendation',
      request,
      metadata || {},
      methodDescriptor_AiService_GetKnowledgeRecommendation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.ai.VectorStore,
 *   !proto.social.ai.VectorStore>}
 */
const methodDescriptor_AiService_AdminCreateVectorStore = new grpc.web.MethodDescriptor(
  '/social.ai.AiService/AdminCreateVectorStore',
  grpc.web.MethodType.UNARY,
  proto.social.ai.VectorStore,
  proto.social.ai.VectorStore,
  /**
   * @param {!proto.social.ai.VectorStore} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.ai.VectorStore.deserializeBinary
);


/**
 * @param {!proto.social.ai.VectorStore} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.ai.VectorStore)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.ai.VectorStore>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.ai.AiServiceClient.prototype.adminCreateVectorStore =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.ai.AiService/AdminCreateVectorStore',
      request,
      metadata || {},
      methodDescriptor_AiService_AdminCreateVectorStore,
      callback);
};


/**
 * @param {!proto.social.ai.VectorStore} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.ai.VectorStore>}
 *     Promise that resolves to the response
 */
proto.social.ai.AiServicePromiseClient.prototype.adminCreateVectorStore =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.ai.AiService/AdminCreateVectorStore',
      request,
      metadata || {},
      methodDescriptor_AiService_AdminCreateVectorStore);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.ai.VectorStore,
 *   !proto.social.ai.VectorStore>}
 */
const methodDescriptor_AiService_AdminUpdateVectorStore = new grpc.web.MethodDescriptor(
  '/social.ai.AiService/AdminUpdateVectorStore',
  grpc.web.MethodType.UNARY,
  proto.social.ai.VectorStore,
  proto.social.ai.VectorStore,
  /**
   * @param {!proto.social.ai.VectorStore} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.ai.VectorStore.deserializeBinary
);


/**
 * @param {!proto.social.ai.VectorStore} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.ai.VectorStore)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.ai.VectorStore>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.ai.AiServiceClient.prototype.adminUpdateVectorStore =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.ai.AiService/AdminUpdateVectorStore',
      request,
      metadata || {},
      methodDescriptor_AiService_AdminUpdateVectorStore,
      callback);
};


/**
 * @param {!proto.social.ai.VectorStore} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.ai.VectorStore>}
 *     Promise that resolves to the response
 */
proto.social.ai.AiServicePromiseClient.prototype.adminUpdateVectorStore =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.ai.AiService/AdminUpdateVectorStore',
      request,
      metadata || {},
      methodDescriptor_AiService_AdminUpdateVectorStore);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.ai.VectorStore,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_AiService_AdminDeleteVectorStore = new grpc.web.MethodDescriptor(
  '/social.ai.AiService/AdminDeleteVectorStore',
  grpc.web.MethodType.UNARY,
  proto.social.ai.VectorStore,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.ai.VectorStore} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.ai.VectorStore} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.ai.AiServiceClient.prototype.adminDeleteVectorStore =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.ai.AiService/AdminDeleteVectorStore',
      request,
      metadata || {},
      methodDescriptor_AiService_AdminDeleteVectorStore,
      callback);
};


/**
 * @param {!proto.social.ai.VectorStore} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.ai.AiServicePromiseClient.prototype.adminDeleteVectorStore =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.ai.AiService/AdminDeleteVectorStore',
      request,
      metadata || {},
      methodDescriptor_AiService_AdminDeleteVectorStore);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.FindRequest,
 *   !proto.social.ai.VectorStoreListResponse>}
 */
const methodDescriptor_AiService_AdminListVectorStores = new grpc.web.MethodDescriptor(
  '/social.ai.AiService/AdminListVectorStores',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.FindRequest,
  proto.social.ai.VectorStoreListResponse,
  /**
   * @param {!proto.social.common.FindRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.ai.VectorStoreListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.FindRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.ai.VectorStoreListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.ai.VectorStoreListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.ai.AiServiceClient.prototype.adminListVectorStores =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.ai.AiService/AdminListVectorStores',
      request,
      metadata || {},
      methodDescriptor_AiService_AdminListVectorStores,
      callback);
};


/**
 * @param {!proto.social.common.FindRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.ai.VectorStoreListResponse>}
 *     Promise that resolves to the response
 */
proto.social.ai.AiServicePromiseClient.prototype.adminListVectorStores =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.ai.AiService/AdminListVectorStores',
      request,
      metadata || {},
      methodDescriptor_AiService_AdminListVectorStores);
};


module.exports = proto.social.ai;

